export enum DeclineRatio {
    Current = 1,
    Historic = 2,
    AllTime = 3,
}
